module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_28-ea3b5b0ade4c18d73e75f0e9f82582b6.jpg";